import React from "react"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"
import { compose } from "redux"
import NotificationAlert from "react-notification-alert"
import classnames from "classnames"
import TagsInput from "react-tagsinput"
import splitString from "split-string"

import { updateMerchant } from "actions/organization/updateProfile"
import { isValidZipCode } from "actions/localActions"

import {
  // Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Container,
  Row,
  Col,
} from "reactstrap"

import Icon from "./Icon"
import ProfileHeader from "components/Headers/ProfileHeader.js"
import { Tabs } from "antd"
import { Component } from "react"
import Packages from "./Packages"
import VehicleType from "./VehicleType"
import Section from "./Section"
import Addon from "./Addon"
import firebase from "firebase"
const storage = firebase.storage()

const AllVehicleTypes = [
  {
    title: "SUV",
    icon: "/img/suv.png",
  },
  {
    title: "Sedan",
    icon: "/img/sedan.png",
  },
  {
    title: "Truck",
    icon: "/img/truck.png",
  },
  // {
  //   title: 'HB',
  //   icon: 'https://picsum.photos/id/1078/200'
  // }
]

const { TabPane } = Tabs

class Profile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: "",
      email: "",
      phone: "",
      logo: "",
      address: "",
      city: "",
      addressZipCode: "",
      vehicleType: [],
      zipCode: [],
      startTime: "",
      closingTime: "",
      validation: {
        form: {},
      },
      activeKey: "1",
    }
  }

  componentDidMount() {
    this._addMerchantDataToState()
  }

  newTabIndex = 0

  onChange = (activeKey) => {
    this.setState({ activeKey })
  }

  onEdit = (targetKey, action) => {
    this[action](targetKey)
  }

  add = () => {
    this._handleAddItem("push")
  }

  remove = (targetKey) => {
    this._handleAddItem("pop")
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.merchant ||
      JSON.stringify(prevProps.merchant) !== JSON.stringify(this.props.merchant)
    ) {
      this._addMerchantDataToState()
    }
  }

  async _addMerchantDataToState() {
    if (this.props.merchant && this.props.merchant.length === 1) {
      const data = this.props.merchant[0]
      const {
        name,
        email,
        phone,
        logo,
        address,
        city,
        addressZipCode,
        vehicleType = [],
        zipCode,
        startTime,
        closingTime,
      } = data
      console.log(`vehicleType`, vehicleType)
      const storageRef = await storage.ref()
      let profileLogoUrl = ""
      if (logo) {
        try {
          profileLogoUrl = await storageRef.child(logo).getDownloadURL()
        } catch (e) {
          profileLogoUrl = ""
        }
      }
      const profileLogo = { imageUrl: profileLogoUrl, loading: false }
      const vT = await Promise.all(
        vehicleType?.map(async (vehicle, index) => ({
          ...vehicle,
          closable: true,
          key: index + 1,
          packages: await Promise.all(
            vehicle?.packages?.map(async (vehiclePackage, packageIndex) => {
              let imageUrl = ""
              if (vehiclePackage.icon) {
                try {
                  imageUrl = await storageRef
                    .child(vehiclePackage.icon)
                    .getDownloadURL()
                  console.log(`imageUrl`, imageUrl)
                } catch (e) {
                  imageUrl = ""
                }
              }
              return (
                {
                  ...vehiclePackage,
                  image: { imageUrl, loading: false },
                  key: packageIndex + 1,
                } || []
              )
            })
          ),
          addon: vehicle?.addon?.map(
            (a, aIndex) =>
              ({
                ...a,
                key: aIndex + 1,
              } || [])
          ),
        }))
      )
      this.setState((prevState, props) => {
        return {
          name: name || "",
          email: email || "",
          phone: phone || "",
          logo: { image: profileLogo } || {},
          address: address || "",
          city: city || "",
          addressZipCode: addressZipCode || "",
          vehicleType: vT,
          zipCode: zipCode ? [...zipCode] : [],
          startTime: startTime || "",
          closingTime: closingTime || "",
        }
      })
    }
  }

  _isValidPhoneNumber(phone) {
    let replacedPhone = phone.replace(/[\s-()]/g, "")
    const regex = /^\d{10}$/
    return regex.test(replacedPhone)
  }

  _handleChange(e, name) {
    if (e && name) {
      let value = e.target.value
      const { validation } = this.state
      const valid = "valid",
        invalid = "invalid"
      validation[name] = valid
      switch (name) {
        case "name":
          if (value.trim().length < 5) validation[name] = invalid
          break

        case "phone":
          value = value.replace(/[\s-)(]/g, "")
          value = value.slice(0, 10)
          if (!value) {
            value = ""
          } else if (value.length <= 3) {
            value = `(${value.substring(0, value.length)}`
          } else if (value.length <= 6) {
            value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}`
          } else if (value.length >= 7) {
            value = `(${value.substring(0, 3)}) ${value.substring(
              3,
              6
            )}-${value.substring(6, value.length)}`
          }
          if (!this._isValidPhoneNumber(value.trim()))
            validation[name] = invalid
          break
        case "address":
          if (value.trim().length < 5) validation[name] = invalid
          break
        case "city":
          if (value.trim().length < 3) validation[name] = invalid
          break
        case "addressZipCode":
          value = value.trim().slice(0, 5)
          if (!isValidZipCode(value)) validation[name] = invalid
          break
        case "startTime":
          if (value.trim().length !== 4) validation[name] = invalid
          break
        case "closingTime":
          if (value.trim().length !== 4) validation[name] = invalid
          break
        default:
          break
      }
      this.setState({
        validation,
        [name]: value,
      })
      return
    }
    console.log(`_handleChange. Issue With Arguments`)
  }

  _handleNestedChange(e, idx, name, subName) {
    if (e && typeof idx === "number" && name && subName) {
      let value = e.target.value
      const id = e.target.id
      const { validation } = this.state
      const { form } = validation
      // console.log(form);
      const invalid = "invalid",
        valid = "valid"
      form[id] = valid
      switch (name) {
        case "packages":
          switch (subName) {
            case "title":
              if (value.trim().length < 4) form[id] = invalid
              break
            case "cost":
              if (value.trim().length < 1) form[id] = invalid
              break
            case "icon":
              if (value.trim().length < 5) form[id] = invalid
              break
            case "shortDescription":
              if (value.trim().length < 5) form[id] = invalid
              break
            case "longDescription":
              if (value.trim().length < 5) form[id] = invalid
              break
            case "duration":
              value = value + ""
              if (value.trim().length < 1) form[id] = invalid
              break
            default:
              break
          }
          break
        case "addon":
          switch (subName) {
            case "title":
              if (value.trim().length < 3) form[id] = invalid
              break
            case "cost":
              if (value.trim().length < 1) form[id] = invalid
              break
            case "icon":
              if (value.trim().length < 5) form[id] = invalid
              break
            case "duration":
              value = value + ""
              if (value.trim().length < 1) form[id] = invalid
              break
            default:
              break
          }
          break
        case "vehicleType":
          // console.log(subName, value);
          switch (subName) {
            case "title":
              if (value.trim().length < 3) form[id] = invalid
              break
            case "cost":
              if (value.trim().length < 1) form[id] = invalid
              break
            case "icon":
              if (value.trim().length < 5) form[id] = invalid
              break
            case "duration":
              value = value + ""
              if (value.trim().length < 1) form[id] = invalid
              break
            default:
              break
          }
          break
        default:
          break
      }
      let data = [...(this.state?.[name] || [])]
      data[idx][subName] = value
      if (name === "vehicleType") {
        const vTypeObj = AllVehicleTypes.find((v) => v.title === value)
        if (vTypeObj) {
          data[idx]["icon"] = vTypeObj.icon
        }
      }
      this.setState({ validation, [name]: data })
      return
    }
    console.log(`_handleNestedChange. Issue With Arguments`)
  }

  _handleNestedChange2(e, idx, subIdx, name, subName, superSubName) {
    if (e && typeof idx === "number" && name && subName && superSubName) {
      console.log(e, typeof idx === "number", name, subName, superSubName)
      let value = e.target.value
      const id = e.target.id
      const { validation } = this.state
      const { form } = validation
      // console.log(form);
      const invalid = "invalid",
        valid = "valid"
      form[id] = valid
      switch (name) {
        case "vehicleType":
          if (subName === "addon") {
            switch (superSubName) {
              case "title":
                if (value.trim().length < 3) form[id] = invalid
                break
              case "cost":
                if (value.trim().length < 1) form[id] = invalid
                break
              case "icon":
                if (value.trim().length < 5) form[id] = invalid
                break
              case "duration":
                value = value + ""
                if (value.trim().length < 1) form[id] = invalid
                break
              default:
                break
            }
          } else if (subName === "packages") {
            switch (superSubName) {
              case "title":
                if (value.trim().length < 3) form[id] = invalid
                break
              case "cost":
                if (value.trim().length < 1) form[id] = invalid
                break
              case "icon":
                if (value.trim().length < 5) form[id] = invalid
                break
              case "shortDescription":
                if (value.trim().length < 5) form[id] = invalid
                break
              case "longDescription":
                if (value.trim().length < 5) form[id] = invalid
                break
              case "duration":
                value = value + ""
                if (value.trim().length < 1) form[id] = invalid
                break
              default:
                break
            }
          }
          break
        default:
          break
      }
      let data = [...this.state[name]]
      let subData = [...data[idx][subName]]
      subData[subIdx][superSubName] = value
      data[idx][subName] = subData
      console.log(JSON.stringify(data, null, 4))
      this.setState({ validation, [name]: data })
      return
    }
    console.log(`_handleNestedChange. Issue With Arguments`)
  }

  _handleAddItem(action) {
    if (action) {
      let hideAdd = false
      const dropDownItems = this._getVehiclesForVehicleTypeDropdown()
      const newObj = {
        title: dropDownItems?.[0]?.title || "",
        cost: "",
        icon: "",
        addon: [],
        packages: [],
        key: this.state.vehicleType.length + 1,
      }
      const data = [...this.state?.vehicleType]
      if (action === "push") {
        if (dropDownItems?.length === 1) {
          hideAdd = true
        }
        data.push(newObj)
      } else if (action === "pop") {
        if (this.state.hideAdd) {
          hideAdd = false
        }
        data.pop()
      }
      // console.log(data);
      this.setState({ vehicleType: [...data], hideAdd })
      return
    }
    console.log(`_handleAddItem. Issue with Argument`)
  }

  _handleNestedAddItem(name, subName, action, idx) {
    if (name && subName && action && typeof idx === "number") {
      // console.log(name, action);

      const data = [...this.state[name]]
      const singleItems = {
        packages: {
          title: "",
          cost: "",
          icon: "",
          duration: "",
          longDescription: "",
          shortDescription: "",
          key: data?.[idx]?.[subName]?.length
            ? data?.[idx]?.[subName]?.length + 1
            : "1",
        },
        addon: {
          title: "",
          cost: "",
          icon: "",
          duration: "",
          key: data?.[idx]?.[subName]?.length
            ? data?.[idx]?.[subName]?.length + 1
            : "1",
        },
        vehicleType: {
          title: "",
          cost: "",
          icon: "",
        },
        zipCode: "",
      }
      if (data[idx][subName]) {
        if (action === "push") {
          // console.log(data[idx]);
          // console.log(data[idx][subName]);
          data[idx][subName].push(singleItems[subName])
        } else if (action === "pop") {
          data[idx][subName].pop()
        }
      } else {
        console.log(subName.toUpperCase(), "not found")
      }
      this.setState({ [name]: [...data] })
      return
    }
    console.log(`_handleNestedAddItem. Issue with Argument`)
  }

  _splitAndFilterZipCodeBySeparator(zipCode = "", separator = ",") {
    if (zipCode && zipCode.length >= 5 && separator) {
      let tempZipCode = splitString(zipCode, { separator })
      tempZipCode = tempZipCode.map((v) => v.trim())
      tempZipCode = tempZipCode.filter((v) => isValidZipCode(v))
      return tempZipCode
    }
  }

  _handleTagsInput(zipCode) {
    console.log(JSON.stringify(zipCode, null, 4))
    if (zipCode && zipCode.length >= 0) {
      let filteredZipCodeDepth0 = [],
        filteredZipCodeDepth1 = []
      filteredZipCodeDepth0 = zipCode.filter((v) => {
        if (isValidZipCode(v)) {
          return true
        }
        // Otherwise Use split-string And return false
        const zipCodeDepth1Comma = this._splitAndFilterZipCodeBySeparator(
          v,
          ","
        ) // Split By Comma
        const zipCodeDepth1WhiteSpace = this._splitAndFilterZipCodeBySeparator(
          v,
          " "
        ) // Then Split By WhiteSpace
        filteredZipCodeDepth1.push(...zipCodeDepth1Comma)
        filteredZipCodeDepth1.push(...zipCodeDepth1WhiteSpace)
        return false
      })
      console.log("DEPTH1", filteredZipCodeDepth1)
      let finalZipCode = [...filteredZipCodeDepth0, ...filteredZipCodeDepth1]
      // finalZipCode = finalZipCode.filter((v, _, initialArr) => !(initialArr.indexOf(v) > -1))
      finalZipCode = [...new Set(finalZipCode)]
      finalZipCode = finalZipCode.sort((a, b) => parseInt(a) - parseInt(b))
      console.log("FINAL", finalZipCode)
      this.setState({ zipCode: finalZipCode })
    }
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  _getOrderSlots() {
    let { startTime, closingTime } = this.state
    startTime = 9 || startTime // Hard Coded
    closingTime = 18 || closingTime // Hard Coded
    let slots = []
    if (startTime && closingTime) {
      // ToDo: Check for startTime or orderTime === 0
      for (let i = startTime; i < closingTime; i += 0.5) {
        let start, end
        if (Number.isInteger(i)) {
          start = i + ":00"
          end = i + ":30"
        } else {
          const num = parseInt(i)
          start = num + ":30"
          end = num + 1 + ":00"
        }
        slots.push({
          start,
          end,
          isBooked: false,
        })
      }
    }
    return slots
  }

  _getVehiclesForVehicleTypeDropdown(currentVehicleType) {
    const { vehicleType } = this.state // Array
    const vehicleTypeTitles = vehicleType.map((v) => v.title)
    const ret = AllVehicleTypes.filter((v) => {
      return (
        v.title === currentVehicleType ||
        !(vehicleTypeTitles.indexOf(v.title) > -1)
      )
      // return (v.title === currentVehicleType) || (!vehicleType.find(item => {item.title === v.title}))
    })
    console.log(JSON.stringify(ret.map((v) => v.title).join(" "), null, 4))
    return ret || []
  }

  updateMerchant = () => {
    const {
      name = "",
      email = "",
      phone = "",
      logo: { imagePath = "" } = {},
      address = "",
      city = "",
      addressZipCode = "",
      vehicleType = [],
      zipCode = [],
      startTime = "",
      closingTime = "",
    } = this.state
    console.log(`vehicleType`, vehicleType)
    const data = {
      name,
      email,
      phone,
      logo: imagePath,
      address,
      city,
      addressZipCode,
      vehicleType: vehicleType?.map(({ key, packages, addon, ...rest }) => ({
        ...rest,
        packages:
          packages?.map(({ key, image, ...rest }) => ({
            ...rest,
          })) || [],
        addon:
          addon?.map(({ key, ...rest }) => ({
            ...rest,
          })) || [],
      })),
      zipCode: zipCode
        .sort((a, b) => parseInt(a) - parseInt(b))
        .filter((v) => !!v),
      startTime,
      closingTime,
    }
    this.props.updateMerchant(data || {}).then((isProfileUpdated) => {
      // const defVal = 'default';
      let message = ""
      if (isProfileUpdated) {
        message = "Merchant Profile Successfully Updated"
        return this.notify("success", message, "Success")
      } else {
        message = "Merchant Profile Not Updated"
        return this.notify("warning", message, "Warning")
      }
    })
  }

  render() {
    const state = this.state
    // console.log(console.log(JSON.stringify(this.state, null, 4)));
    const { vehicleType, activeKey, hideAdd } = this.state
    console.log(`this.props`, this.props)
    console.log(`state`, state)
    return (
      <>
        <ProfileHeader name={this.state.name} />
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <Container className="mt--6" fluid>
          <Row>
            <Col className="order-xl-1" xs="12">
              <Card>
                <CardHeader>
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Edit Profile</h3>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form>
                    <Section title="Merchant Information">
                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="merchant-name"
                            >
                              Merchant Name
                            </label>
                            <Input
                              value={state.name}
                              id="merchant-name"
                              placeholder="Merchant Name"
                              type="text"
                              valid={state.validation.name === "valid"}
                              invalid={state.validation.name === "invalid"}
                              onChange={(e) => this._handleChange(e, "name")}
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Merchant Name Should Be At Least 5 Characters!
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="merchant-email"
                            >
                              Email Address
                            </label>
                            <Input
                              disabled
                              id="merchant-email"
                              defaultValue={state.email}
                              placeholder="name@example.com"
                              type="email"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="merchant-logo"
                            >
                              Logo
                            </label>
                            {/* <Input
                              value={state.logo}
                              id="merchant-logo"
                              placeholder="Logo"
                              type="text"
                              valid={state.validation.logo === "valid"}
                              invalid={state.validation.logo === "invalid"}
                              onChange={(e) => this._handleChange(e, "logo")}
                              autoComplete="off"
                            /> */}
                            <Icon
                              image={state?.logo?.image}
                              setImage={(image) =>
                                this._handleChange(
                                  {
                                    target: {
                                      value: { ...state?.logo, image },
                                    },
                                  },
                                  "logo"
                                )
                              }
                              auth={this.props.auth}
                              setImagePath={(imagePath) =>
                                this._handleChange(
                                  {
                                    target: {
                                      value: { ...state?.logo, imagePath },
                                    },
                                  },
                                  "logo"
                                )
                              }
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Logo Should Be At Least 5 Characters!
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          {/* <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="merchant-startTime"
                            >
                              Start Time
                            </label>
                            <Input
                              value={state.startTime}
                              id="merchant-startTime"
                              placeholder="24 Hour Format"
                              type="text"
                              valid={state.validation.startTime === 'valid'}
                              invalid={state.validation.startTime === 'invalid'}
                              onChange={e => this._handleChange(e, 'startTime')}
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">Start Time Should Be At 4 Characters!</div>
                          </FormGroup> */}
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="merchant-startTime"
                            >
                              Start Time
                            </label>
                            <InputGroup
                              className={classnames("input-group-merge", {
                                focused: this.state.focussedStartTime,
                              })}
                            >
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fas fa-clock" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                value={this.state.startTime || "09:00:00"}
                                onFocus={(e) =>
                                  this.setState({ focussedStartTime: true })
                                }
                                onBlur={(e) =>
                                  this.setState({ focussedStartTime: false })
                                }
                                onChange={(e) =>
                                  this._handleChange(e, "startTime")
                                }
                                autoComplete="off"
                                type="time"
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          {/* <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="merchant-closingTime"
                            >
                              Closing Time
                            </label>
                            <Input
                              value={state.closingTime}
                              id="merchant-closingTime"
                              placeholder="24 Hour Format"
                              type="text"
                              valid={state.validation.closingTime === 'valid'}
                              invalid={state.validation.closingTime === 'invalid'}
                              onChange={e => this._handleChange(e, 'closingTime')}
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">Closing Time Should Be At 4 Characters!</div>
                          </FormGroup> */}
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="merchant-startTime"
                            >
                              Closing Time
                            </label>
                            <InputGroup
                              className={classnames("input-group-merge", {
                                focused: this.state.focussedClosingTime,
                              })}
                            >
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fas fa-clock" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                value={this.state.closingTime || "18:00:00"}
                                onFocus={(e) =>
                                  this.setState({ focussedClosingTime: true })
                                }
                                onBlur={(e) =>
                                  this.setState({ focussedClosingTime: false })
                                }
                                onChange={(e) =>
                                  this._handleChange(e, "closingTime")
                                }
                                autoComplete="off"
                                type="time"
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Section>

                    <Section title="Contact Information">
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-address"
                            >
                              Work Address
                            </label>
                            <Input
                              value={state.address}
                              id="input-address"
                              placeholder="Work Address"
                              type="text"
                              valid={state.validation.address === "valid"}
                              invalid={state.validation.address === "invalid"}
                              onChange={(e) => this._handleChange(e, "address")}
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Address Should Be At Least 5 Characters!
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="phone-number"
                            >
                              Phone
                            </label>
                            <Input
                              autoComplete="off"
                              id="phone-number"
                              onChange={(e) => this._handleChange(e, "phone")}
                              placeholder="(987) 654-3210"
                              type="phone"
                              valid={this.state.validation.phone === "valid"}
                              invalid={
                                this.state.validation.phone === "invalid"
                              }
                              value={this.state.phone}
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Invalid Phone Number
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-city"
                            >
                              City
                            </label>
                            <Input
                              value={state.city}
                              id="input-city"
                              placeholder="City"
                              type="text"
                              valid={state.validation.city === "valid"}
                              invalid={state.validation.city === "invalid"}
                              onChange={(e) => this._handleChange(e, "city")}
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              City Should Be At Least 3 Characters!
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-country"
                            >
                              Country
                            </label>
                            <Input
                              disabled
                              defaultValue="United States"
                              id="input-country"
                              placeholder="Country"
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-zipCode"
                            >
                              Zip Code
                            </label>
                            <Input
                              value={state.addressZipCode}
                              id="input-zipCode"
                              placeholder="Zip Code"
                              type="text"
                              valid={
                                state.validation.addressZipCode === "valid"
                              }
                              invalid={
                                state.validation.addressZipCode === "invalid"
                              }
                              onChange={(e) =>
                                this._handleChange(e, "addressZipCode")
                              }
                              autoComplete="off"
                            />
                            <div className="valid-feedback">Looks Good!</div>
                            <div className="invalid-feedback">
                              Zip Code Should Be Numeric And 5 Characters!
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Section>
                    <Tabs
                      type="editable-card"
                      onChange={this.onChange}
                      activeKey={activeKey}
                      onEdit={this.onEdit}
                      hideAdd={hideAdd}
                    >
                      {vehicleType.map((pane, idx) => (
                        <TabPane
                          tab={pane.title}
                          key={pane.key}
                          closable={pane.closable}
                        >
                          <Section title="Vehicle Type">
                            <VehicleType
                              title={pane.title}
                              idx={idx}
                              handleNestedChange={(e, idx, name, subName) =>
                                this._handleNestedChange(e, idx, name, subName)
                              }
                              getVehiclesForVehicleTypeDropdown={(
                                currentVehicleType
                              ) =>
                                this._getVehiclesForVehicleTypeDropdown(
                                  currentVehicleType
                                )
                              }
                            />
                            <Packages
                              packages={pane?.packages || []}
                              idx={idx}
                              handleChange={(e, subIdx, superSubName) =>
                                this._handleNestedChange2(
                                  e,
                                  idx,
                                  subIdx,
                                  "vehicleType",
                                  "packages",
                                  superSubName
                                )
                              }
                              parentState={this.state}
                              handleAddItem={(action) =>
                                this._handleNestedAddItem(
                                  "vehicleType",
                                  "packages",
                                  action,
                                  idx
                                )
                              }
                              auth={this.props.auth}
                            />
                            <Addon
                              addon={pane?.addon || []}
                              idx={idx}
                              parentState={this.state}
                              handleChange={(e, subIdx, superSubName) =>
                                this._handleNestedChange2(
                                  e,
                                  idx,
                                  subIdx,
                                  "vehicleType",
                                  "addon",
                                  superSubName
                                )
                              }
                              handleAddItem={(action) =>
                                this._handleNestedAddItem(
                                  "vehicleType",
                                  "addon",
                                  action,
                                  idx
                                )
                              }
                            />
                          </Section>
                        </TabPane>
                      ))}
                    </Tabs>
                    <Section title="Zip Code">
                      <Row>
                        <Col id="merchant-profile-zip-code" xs={12}>
                          {state && state.zipCode && (
                            <TagsInput
                              onlyUnique
                              className="bootstrap-tagsinput"
                              onChange={(zipCode) =>
                                this._handleTagsInput(zipCode)
                              }
                              value={this.state.zipCode}
                              tagProps={{
                                className: "tag badge mr-1 bg-chift",
                              }}
                              inputProps={{
                                className: "",
                                placeholder: "",
                              }}
                            />
                          )}
                        </Col>
                      </Row>
                    </Section>
                    <Button
                      className="float-right"
                      color="primary"
                      onClick={this.updateMerchant}
                    >
                      Update
                    </Button>
                    <div className="clearfix" />
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

const AddItems = ({ onClick, name }) => {
  return (
    <div>
      <span
        className="text-success mr-2"
        style={{ cursor: "pointer" }}
        onClick={() => onClick(name, "push")}
      >
        <i className="fa fa-lg fa-plus-circle" aria-hidden="true" />
      </span>
      <span
        className="text-success"
        style={{ cursor: "pointer" }}
        onClick={() => onClick(name, "pop")}
      >
        <i className="fa fa-lg fa-minus-circle" aria-hidden="true" />
      </span>
    </div>
  )
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    auth: state.firebase.auth,
    merchant: state.firestore.ordered.merchant,
    email: state.firebase.auth.email,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateMerchant: (state) => dispatch(updateMerchant(state)),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: `merchants`,
      where: ["email", "==", props.email],
      storeAs: "merchant",
    },
  ])
)(Profile)
